import Api from '@configuratorware/configurator-frontendgui/Framework/Api';
import { initLanguage } from '@configuratorware/configurator-frontendgui/App/Translations';
import Cookies from 'js-cookie';

const setLanguage = (languagesIso: string) => {
  window.changeLocale(languagesIso);

  Api.setLanguage(languagesIso.replace('_', '-'));
  initLanguage(languagesIso.replace('_', '-'));

  Cookies.set('language', languagesIso);
};

const getLanguage = () => {
  const language = Cookies.get('language');
  if (language) {
    return language;
  }
  return 'de_DE';
};

export { setLanguage, getLanguage };
